module.exports = __webpack_public_path__ + "static/media/ios-flower.396e6d67.svg";